module.exports = __webpack_public_path__ + "media/application/images/svgs/file-94bc50d1b35a190795f415bb85869bd6.svg";